import { z } from 'zod';

export const readingPropertySchema = z.object({
  name: z.string().min(1, 'Nome da propriedade de leitura é obrigatório'),
  units: z.array(z.string().min(1, 'Nome da unidade é obrigatório')).min(1, 'Pelo menos uma unidade é obrigatória'),
});

export const propertySchema = z.object({
  name: z.string().min(1, 'Nome da propriedade é obrigatório'),
  type: z.enum(['string', 'number', 'enum'], {
    required_error: 'Tipo da propriedade é obrigatório',
    invalid_type_error: 'Tipo deve ser string, number ou enum',
  }),
  enumValues: z.array(z.string().min(1, 'Valor do enum não pode ser vazio')).optional(),
  required: z.boolean().default(false),
}).refine(
  (data) => {
    if (data.type === 'enum') {
      return data.enumValues && data.enumValues.length > 0;
    }
    return true;
  },
  {
    message: 'Valores do enum são obrigatórios quando o tipo é enum',
    path: ['enumValues'],
  }
);

export const instrumentCategorySchema = z.object({
  name: z.string().min(1, 'Nome da categoria é obrigatório'),
  readingProperties: z.array(readingPropertySchema).min(1, 'Pelo menos uma propriedade de leitura é obrigatória'),
  properties: z.array(propertySchema).optional().default([]),
});

export const defaultInstrumentCategory = {
  name: '',
  readingProperties: [
    {
      name: '',
      units: [''],
    }
  ],
  properties: [],
};

export const createEmptyReadingProperty = () => ({
  name: '',
  units: [''],
});

export const createEmptyProperty = () => ({
  name: '',
  type: 'string',
  enumValues: [],
  required: false,
});